import dynamic from 'next/dynamic';

export const loadReactPdf = () =>
  import('react-pdf').then((mod) => {
    mod.pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
    return mod;
  });

export const loadPdfjs = () => loadReactPdf().then((mod) => mod.pdfjs);

export const ReactPdfDocument = dynamic(() => loadReactPdf().then((m) => m.Document), {
  ssr: false,
});

export const ReactPdfPage = dynamic(() => loadReactPdf().then((m) => m.Page), {
  ssr: false,
});
